import React, { Suspense } from 'react'
import { Hr, Loading, TitleController } from '@pandiafi/design-system'
import { useTranslation } from 'react-i18next'

import { useContractNotificationCategories } from '../hooks/useContractNotificationCategories'

import { useContractPaths } from 'hooks/useContractPaths/useContractPaths'
import { Breakpoint, ResidentNotifications, View } from 'components'

type ContractChangesViewProps = {
  title: string
  banner: React.ReactNode
  sidebarInfo: React.ReactNode
  children: React.ReactNode
}

export const ContractChangesView: React.FC<ContractChangesViewProps> = ({
  title,
  banner,
  sidebarInfo,
  children,
}) => {
  const { t } = useTranslation(['common'])
  const { frontPagePath } = useContractPaths()
  const { contractNotificationCategories } = useContractNotificationCategories()

  return (
    <TitleController title={title}>
      <View>
        <View.Header>
          <View.HeaderLink to={frontPagePath}>
            {t('common:views.home')}
          </View.HeaderLink>

          <View.HeaderTitle>{title}</View.HeaderTitle>

          <Breakpoint show tablet phone>
            <ResidentNotifications
              categories={contractNotificationCategories}
            />
          </Breakpoint>
        </View.Header>
        <View.Sidebar>
          <Breakpoint show desktop>
            <ResidentNotifications
              categories={contractNotificationCategories}
            />
          </Breakpoint>

          <Breakpoint hide tablet desktop>
            {banner}
          </Breakpoint>

          {sidebarInfo}
          <Hr className="my-4 tablet:hidden desktop:hidden" />
        </View.Sidebar>
        <View.Content>
          <>
            <Breakpoint show tablet desktop>
              {banner}
            </Breakpoint>

            <Suspense fallback={<Loading variant="details" />}>
              {children}
            </Suspense>
          </>
        </View.Content>
      </View>
    </TitleController>
  )
}
